import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { TorneioProfile } from '../services/torneioService'
import { useAuth } from '../context/AuthContext'
import {
  CRIAR_SEGUIDOR_MUTATION,
  DELETAR_SEGUIDOR_MUTATION,
  CriarSeguidorResponse,
  SEGUIDOR_USUARIO_TORNEIO,
  SeguidorUsuarioTorneioData,
  SeguidorUsuarioTorneioVars,
} from '../services/seguidorService'
import ShareButton from './ShareButton'
import TournamentShareModal from './tournament/TournamentShareModal'

interface ProfileCardTournamentProps {
  torneio?: TorneioProfile
}

const ProfileCardTournament: React.FC<ProfileCardTournamentProps> = ({ torneio }) => {
  const auth = useAuth()
  const userObj =
    (auth?.user as any) ||
    (typeof window !== 'undefined' ? JSON.parse(localStorage.getItem('user') || 'null') : null)
  const seguidorUserId = userObj?.atleta?.id ?? '';
  const isAdmin = userObj?.role === 'ADMIN';

  const [seguir, { loading: loadingSeguir }] = useMutation<{
    criarSeguidor: CriarSeguidorResponse
  }, { input: any }>(CRIAR_SEGUIDOR_MUTATION)
  const [deletar, { loading: loadingDeletar }] = useMutation(DELETAR_SEGUIDOR_MUTATION)
  const [followId, setFollowId] = useState<string | null>(null)
  const [erro, setErro] = useState('')
  const [shareModalOpen, setShareModalOpen] = useState(false)

  const { data: seguidorData } = useQuery<SeguidorUsuarioTorneioData, SeguidorUsuarioTorneioVars>(
    SEGUIDOR_USUARIO_TORNEIO,
    {
      variables: { seguidorId: seguidorUserId, seguidoTorneioId: torneio?.id || '' },
      skip: !seguidorUserId || !torneio?.id,
      fetchPolicy: 'network-only',
    }
  )

  useEffect(() => {
    if (seguidorData?.seguidorPorSeguidorIdSeguidoTorneioId?.id) {
      setFollowId(seguidorData.seguidorPorSeguidorIdSeguidoTorneioId.id)
    } else {
      setFollowId(null)
    }
  }, [seguidorData])

  const handleClick = async () => {
    if (!seguidorUserId || !torneio?.id) return
    setErro('')
    try {
      if (followId) {
        await deletar({ variables: { id: followId } })
        setFollowId(null)
      } else {
        setFollowId('temp')
        const { data } = await seguir({
          variables: {
            input: {
              seguidorId: seguidorUserId,
              seguidoAtletaId: null,
              seguidoTorneioId: torneio.id,
            },
          },
        })
        const id = data?.criarSeguidor.id
        if (id) setFollowId(id)
        else setFollowId(null)
      }
    } catch (e) {
      setErro('Não foi possível atualizar. Tente novamente.')
      if (!followId || followId === 'temp') setFollowId(null)
    }
  }

  return (
    <div className="card w-100 shadow-xss rounded-xxl border-0 mb-3 mt-3 overflow-hidden">
      <div
        id='banner-tournament'
        className="card-body position-relative h240 bg-image-cover bg-image-center"
        style={{ backgroundImage: `url("${torneio?.bannerUrl || '/assets/images/comingsoon.svg'}")` }}
      ></div>
      <div className="card-body d-block pt-4 position-relative">
        <figure className="avatar mt--6 position-relative w75 z-index-1 me-auto">
          <img
            src={torneio?.avatarUrl || '/assets/images/user.png'}
            alt={torneio?.nome || 'avatar'}
            className="p-1 bg-white rounded-xl w-100"
          />
        </figure>
        <h4 id='nome-tournament' className="font-xs ls-1 fw-700 text-grey-900">
          {torneio?.nome}
          {torneio?.username && (
            <span id='tag-tournament' className="d-block font-xssss fw-500 mt-1 lh-3 text-primary">
              @{torneio.username}
            </span>
          )}
        </h4>
            <div className="d-flex align-items-center justify-content-center position-absolute right-15 top-10 mt-2 me-2 gap-2">
              <ShareButton
                onClick={() => setShareModalOpen(true)}
                variant="outlined"
                size="small"
                className="d-none d-lg-block"
              />
              {!isAdmin && (
                <button
                  onClick={handleClick}
                  disabled={loadingSeguir || loadingDeletar || followId === 'temp'}
                  className={`d-none d-lg-block p-3 z-index-1 rounded-3 font-xsssss text-uppercase fw-700 ls-3 btn ${followId ? 'btn-secondary' : 'btn-primary'}`}
                >
                  {loadingSeguir || loadingDeletar
                    ? 'Aguarde...'
                    : followId
                    ? 'SEGUINDO'
                    : 'SEGUIR'}
                </button>
              )}
            </div>
            {erro && (
              <div className="alert alert-danger mt-2" role="alert">
                {erro}
              </div>
            )}
      </div>

      <TournamentShareModal
        open={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        torneioId={torneio?.id || ''}
        torneioNome={torneio?.nome}
      />
    </div>
  )
}

export default ProfileCardTournament
